import PropTypes from 'prop-types';

export const CurrencyPropTypes = PropTypes.shape({
  countryCode: PropTypes.string.isRequired,
  countryName: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  precision: PropTypes.number.isRequired,
});

export const CurrenciesPropTypes = PropTypes.arrayOf(CurrencyPropTypes);
